import {
  FETCH_PAGINATED_PRICE_FIELDS,
  FETCH_ALL_PRICE_FIELDS,
  RESET_PRICE_FIELDS,
} from './../../mutation-types';

export default {
  [FETCH_PAGINATED_PRICE_FIELDS](state, { priceFields, pagination }) {
    state.items = priceFields;
    state.pagination = pagination;
  },

  [FETCH_ALL_PRICE_FIELDS](state, priceFields) {
    state.all = priceFields;
  },

  [RESET_PRICE_FIELDS](state) {
    state.all = [];
    state.items = [];
    state.pagination = {};
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/priceField/mutations.js